// extracted by mini-css-extract-plugin
module.exports = {"PrivacyPolicy":"styles_PrivacyPolicy__7Rw_k","parentList":"styles_parentList__Z1iI0","childList":"styles_childList__ml7v4"};